var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"w-full"},[_vm._v(" Menu ")]),_c('v-select',{staticClass:"mb-6",attrs:{"options":_vm.menus,"clearable":false},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }